module.exports = __webpack_public_path__ + "img/CPTemp9.b015f9a6.png";